import React, { useEffect, useState } from 'react'
import { confirmable } from 'react-confirm'
import { message, Modal, Col, Input, Row, DatePicker, Select, Spin, Switch } from "antd";

import "./AddRecipeListPage.css"
import { isEmpty } from 'utils/GlobalFunctions';
import ProductImageWidget from './ProductImageWidget';
import moment from "moment"
import CommonButton from 'components/ButtonWidgets/CommonButton/CommonButton';
import ProductInputNumber from 'components/InputWidgets/InputNumber/ProductInputNumber';
import ProductWYSIWYGEditor from 'components/ProductPage/ProductWYSIWYGEditor/ProductWYSIWYGEditor';
const { Option } = Select;
const { RangePicker } = DatePicker;

function AddRecipeListPage(props) {
  const { show, proceed, record, title, isEditing } = props

  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {

  }, [])

  useEffect(() => {
    if (record !== undefined) {
      setData({ ...record });
    } else {
      setData({
        "status": "0"
      });
    }
  }, [record?.id, record?.thumbnail_image]); // Only update when record id or thumbnail changes

  const onViewMode = (checked) => {
    setData({
      ...data, "status": checked === true ? "1" : "0"
    });
  }

  const validateFields = async () => {
    var errorList = Array();
    errorList = isEmpty(data, "name", errorList);

    // Check if image_name exists and is not empty array
    const hasImages = data["thumbnail_image"] !== undefined && data["thumbnail_image"] !== "" &&
                      (Array.isArray(data["thumbnail_image"]) ? data["thumbnail_image"].length > 0 : true);
    const hasImageFiles = data["image_name"] !== undefined &&
                          (Array.isArray(data["image_name"]) ? data["image_name"].length > 0 : data["image_name"] instanceof File);

    if (!hasImages && !hasImageFiles) {
      errorList = [...errorList, "image_name"]
    }
    setErrorField([...errorList]);
    return errorList.length == 0;
  };


  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      closable={true}
      maskClosable={false}
      title={title}
      className="custom-add-main-image-dlg"
      onOk={async () => {
        if ((await validateFields()) === false) return;
        proceed({
          ...data,
        });
      }}
    >
      <Spin spinning={isBusy}>

        <div>
          <Row justify="space-between" align="middle" style={{ marginBottom: "10px" }}>
            <Col>
              <div>Image*</div>
            </Col>
            <Col>
              <Switch
                checkedChildren="Show"
                unCheckedChildren="Hide"
                onChange={onViewMode}
                checked={data["status"] === "1" ? true : false}
              />
            </Col>
          </Row>
          <ProductImageWidget
            field={"thumbnail_image"}
            productInfo={data}
            setProductInfo={setData}
            errorField={errorField}
            setErrorField={setErrorField}
          />
          <Row align={"middle"} gutter={16} style={{ marginTop: "10px" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div>Name*</div>
              <ProductWYSIWYGEditor
                placeholder="Enter name..."
                field={"name"}
                productInfo={data}
                setProductInfo={setData}
                errorField={errorField}
                setErrorField={setErrorField}
              />
            </Col>
          </Row>




        </div>
      </Spin>
    </Modal>
  );
}

export default confirmable(AddRecipeListPage)
